import { jsx as _jsx } from "react/jsx-runtime";
import { CustomFieldTypeName } from "@air/api/types";
import { memo, useCallback, useState } from "react";
import { CustomFieldSelect } from "~/components/CustomFields/CustomFieldInput/CustomFieldSelect";
import { chipsToCustomField, chipToCustomField } from "~/components/CustomFields/CustomFieldInput/utils";
import { useGetPublicCustomFieldOptions } from "~/swr-hooks/customFields/useGetPublicCustomFieldOptions";
import { useUpdatePublicItemsCustomFieldValue } from "~/utils/CustomFields/useUpdatePublicItemsCustomFieldValue";
export const PublicBoardCustomFieldSelect = /*#__PURE__*/ memo((param)=>{
    let { field, trackingLocation, canEditCustomFields, boardId, ...rest } = param;
    const [shouldLoadOptions, setShouldLoadOptions] = useState(false);
    const { data: cfOptions } = useGetPublicCustomFieldOptions({
        customFieldId: field.id,
        enabled: !shouldLoadOptions
    });
    const { updatePublicItemsCustomFieldValue } = useUpdatePublicItemsCustomFieldValue();
    const onSelectionChange = useCallback(async (param)=>{
        let { addedChips, removedChips, chips } = param;
        if (field.type.title === CustomFieldTypeName.singleSelect) {
            const value = chips.length && !!cfOptions ? chipToCustomField(chips[0], cfOptions.data) : null;
            await updatePublicItemsCustomFieldValue({
                boardIds: [
                    boardId
                ],
                baseCustomField: field,
                nextValue: value,
                trackingLocation
            });
        } else {
            const selectedFields = chips.length && !!cfOptions ? chipsToCustomField(chips, cfOptions.data) : [];
            await updatePublicItemsCustomFieldValue({
                boardIds: [
                    boardId
                ],
                baseCustomField: field,
                nextValues: selectedFields,
                multiValuesToAdd: addedChips && cfOptions ? chipsToCustomField(addedChips, cfOptions.data) : undefined,
                multiValueIdsToRemove: removedChips === null || removedChips === void 0 ? void 0 : removedChips.map((chip)=>chip.value),
                trackingLocation
            });
        }
    }, [
        boardId,
        cfOptions,
        field,
        trackingLocation,
        updatePublicItemsCustomFieldValue
    ]);
    return /*#__PURE__*/ _jsx(CustomFieldSelect, {
        ...rest,
        field: field,
        onSelectionChange: onSelectionChange,
        cfOptions: cfOptions,
        onOptionsOpen: ()=>setShouldLoadOptions(true),
        isLoading: shouldLoadOptions && !cfOptions,
        disabled: !canEditCustomFields
    });
});
PublicBoardCustomFieldSelect.displayName = "PublicBoardCustomFieldSelect";
